// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__v2uv2","left":"Virtual_left__fDO-o","wrapper":"Virtual_wrapper__GqDxM"};